class VariantPicker extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('[data-variant-id]');
    // Options render as either radio pills or a dropdown (e.g. Size).
    this.inputs = this.querySelectorAll('.variant-picker__input, .variant-picker__select');
    this.inputs.forEach((input) => {
      input.addEventListener('change', () => this.onOptionChange());
    });
  }

  onOptionChange() {
    const selectedValues = {};
    this.inputs.forEach((input) => {
      // Dropdowns contribute their value once it's a real choice, not the
      // blank value; radios only when checked.
      if ((input.tagName === 'SELECT' && input.value !== '') || input.checked) {
        selectedValues[input.dataset.optionPosition] = input.value;
      }
    });

    const variantKey = Object.keys(selectedValues)
      .sort()
      .map((k) => selectedValues[k])
      .join('|||');

    const match = Array.from(this.select.options).find(
      (opt) => opt.dataset.variantOptions === variantKey
    );

    if (!match) return;

    this.select.value = match.value;
    this.updateUrl(match.value);
    this.dispatchVariantChange(match);
  }

  updateUrl(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  }

  dispatchVariantChange(option) {
    this.dispatchEvent(
      new CustomEvent('variant:change', {
        bubbles: true,
        detail: {
          id: option.value,
          price: option.dataset.price,
          comparePrice: option.dataset.comparePrice || null,
          available: option.dataset.available === 'true',
        },
      })
    );
  }
}

if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}
